import React from "react"
import Tr from "translations/Translations";
import GeneralInfoEntry from "../../panels/generalInfo/components/GeneralInfoEntry";
import {ContractorConsorciumTypes, ContractorConsorciumTypesLabel} from "constants/ContractorConsorciumTypes";
import ConsorciumTable from "../commonData/ConsorciumTable";
import YesNo from "components/YesNo";
import getObjectValue from "libs/getObjectValue";
import {useDidUpdateEffect} from "hooks/useDidUpdateEffect";
import {makeStyles} from "@material-ui/core";

const useStyle = makeStyles(theme=> ({
    marginTop: {
        marginTop: theme.spacing()
    }
}))

function OfferPositionConsorciants(
    {
        formikProps,
        disabled,
        offerEdit,
        positionFormId
    }) {
    const classes = useStyle();

    useDidUpdateEffect(() => {
        if (offerEdit.commonData.consorciumType !== ContractorConsorciumTypes.POSITION) {
            formikProps.setFieldValue("consorciumOnPosition", false);
            formikProps.setFieldValue("consorciants", null);
        }
    }, [offerEdit.commonData.consorciumType])

    const consorciumEnabled = !!getObjectValue("consorciumOnPosition", formikProps.values, false);
    return (
        <GeneralInfoEntry biggerLabel label={`${Tr('consorcium')}: ${ContractorConsorciumTypesLabel(offerEdit.commonData.consorciumType)}`}
                          collapsible={offerEdit.commonData.consorciumType === ContractorConsorciumTypes.POSITION} defaultCollapsed={false}>
            {
                offerEdit.commonData.consorciumType === ContractorConsorciumTypes.POSITION && <>
                    <YesNo
                        label={Tr('consorciant_position_label')}
                        id='consorciumOnPosition'
                        formikProps={formikProps}
                        disabled={disabled}
                        className={classes.marginTop}
                    />

                    {consorciumEnabled &&
                        <ConsorciumTable
                            id="consorciants"
                            formikProps={formikProps}
                            contractor={offerEdit.contractor}
                            companySize={offerEdit.commonData.companySize}
                            disabled={disabled}
                            positionFormId={positionFormId}
                        />
                    }
                </>
            }
        </GeneralInfoEntry>)

}

OfferPositionConsorciants.propTypes = {

}

export default OfferPositionConsorciants;